/* eslint-disable indent */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef, memo } from "react";
import {
  Form,
  Row,
  Col,
  Spin,
  Button,
  Card,
  Empty,
  message,
  notification,
} from "antd";
import "./style.scss";
import {
  capitalise,
  capitalize,
  firstLetterCapitaliseStr,
  formatReceiverAddress,
  getCreatedDateNEnd,
  normalizeService,
  splitReceiverName,
} from "../../../utils";
import ImageViewer from "./ImageViewer";
import useClientAndDepartment from "./useClientAndDepartment ";
import { useReactToPrint } from "react-to-print";
import Heading from "../../../components/Heading";
import "../style.scss";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import EwayBillDrawer from "./EwayBillDrawer/EwayBillDrawer";
import ChildDrawer from "./childDrawer";
import ReturnAddressDrawer from "./ReturnAddressDrawer";
import RecentBooking from "./RecentBooking";
import NewRecentBookingTable from "./RecentBooking/NewRecentBookingTable";
import AddressCard from "./AddressCard";
import moment from "moment";
import axios from "axios";
import CreditFormItems from "./CreditFormItems";
import { useLocation, useParams } from "react-router-dom";
import API from "../../../api";
import urls from "../../../api/urls";
import { getToken } from "../../../utils/worker";
import useCustomNavigate from "../../../components/customNavigationHook";
import PrintBooking from "../../PrintBooking";
import { shallowEqual, useSelector } from "react-redux";
import { convertCurrentToPrevBookingData } from "../../../utils/bookingDataConverter";
import transformToNewFormat from "../../../utils/OldToNewBookingFormat";

const BaseCreditBooking = ({
  printer,
  contentDiscriptionData,
  travelByOptions,
  allPincodes,
  insuredOptions,
  getFocusFirstInput,
  handlePrinting,
  reviverNameAndAddress,
  isClientAdmin = false,
  customProps = {},
}) => {
  const [form] = Form.useForm();

  const { id, date, type = "CREDIT" } = useParams();
  const { userInfo } = JSON.parse(localStorage?.getItem("userId")) || "";
  const company = JSON.parse(localStorage.getItem("selectedCompany")) || null;

  const [ewayBillCheck, setEwayBillCheck] = useState(false);
  const [isNonDox, setIsNonDox] = useState(false);
  const [childShipments, setChildShipments] = useState([]);
  const [shipmentContentOptions, setShipmentContentOptions] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [ewayDrawer, setEwayDrawer] = useState(false);
  const [childDrawer, setChildDrawer] = useState(false);
  const [radioActive, setRadioActive] = useState("default");
  const [returnAddressDrawer, setReturnAddressDrawer] = useState(false);
  const [dropDownChanges, setdropDownChanges] = useState(false);
  const [activePinOption, setActivePinOption] = useState(null);
  const [docValidate, setDocValidate] = useState({});
  const [allPinOptions, setAllPinOptions] = useState([]);
  const [recentBookingsData, setRecentBookingsData] = useState([]);
  const [useGoogleAddr, setUseGoogleAddr] = useState(false);
  const [nonDoxValueReq, setNonDoxValueReq] = useState(true);
  const [resetForm, setResetForm] = useState(false);
  const [docLoading, setdocLoading] = useState(false);
  const [ewayForm] = Form.useForm();
  const [childDrawerform] = Form.useForm();
  const debounceTimeout = useRef(null);
  const [clientEditChargeVal, setclientEditChargeVal] = useState(0);
  const [returnAddressform] = Form.useForm();
  const navigate = useCustomNavigate();
  const currentEnv = process.env.REACT_APP_ENV;
  const {
    UPDATE_SINGLE_BOOKING,
    GET_SINGEL_DOCUMENT_DETAILS_AWB,
    GET_SINGEL_DOCUMENT_DETAILS_AWB_BE,
    LISTING_BOOKING_API,
    CONFIRM_BOOKING_UTM,
    GET_UTM_API_BOOKING_DETAILS,
    POST_NEW_RETAIL_BOOKING,
  } = urls;
  const history = useLocation();
  const [vayuCharges, setVayuCharges] = useState(null);
  const user_premiseId = JSON.parse(localStorage?.getItem("userId"));

  const {
    loading,
    clientList,
    department,
    clientDetails,
    pinCodeServiceableStatus,
    bookingDetails,
    doxandNonDoxChange,
    savedReturnAddressList,
    reviverStateCity,
    allEwayBills,
    mainEwayValidationStatus,
    servicesOptions,
    setAllEwayBills,
    getDepartMentQA,
    setEditClientDepartment,
    getClients,
    setClientDepartment,
    setPinCodeServiceableStatus,
    getDeliveryPincode,
    eWayBillHandle,
    submitWithPostDetails,
    getRecvNameAddressList,
    updateReturnAddressList,
    documentValidate,
    handleOnEnter,
    containsAllPairs,
    setReviverStateCity,
    setMainEwayValidationStatus,
    getSingleShipmentDetails,
    setServiceOptions,
    editShipmentDetails,
    setLoading,
    handleTabEnter,
    getClientEditRates,
    pincodeLoading,
    setEditShipmentDetails,
    newDataFormat,
    setNewDataFormat,
  } = useClientAndDepartment(userInfo, form);

  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    const getRecentBookings = async () => {
      if (type === "OCR") {
        resetCallBack();
        const startDate = moment().subtract(30, "day").format("YYYY-MM-DD");
        const endDate = moment().format("YYYY-MM-DD");
        const date = `&startDate=${startDate}&endDate=${endDate}`;

        try {
          const url = `${LISTING_BOOKING_API}?companyId=${company?.key}&status=DRAFT&bookingType=credit${date}&utm=OCR&page=1&limit=6`;

          const res = await API.Api(url).getWithAllHeaders();
          setRecentBookingsData(res?.response?.data?.shipments || []);
        } catch (error) {
          console.log("error: ", error);
        }
      } else {
        setRecentBookingsData(
          JSON.parse(localStorage.getItem("creditRecentBookings")) || []
        );
      }
    };
    getRecentBookings();
  }, []);

  useEffect(() => {
    if (clientList) {
      setFilteredOptions(clientList);
    }
  }, [clientList]);

  const senderAddress = bookingDetails?.addressDetails;

  const [lastSubmitTime, setLastSubmitTime] = React.useState(0);
  const THROTTLE_TIME = 2000; // 2 seconds

  // Common functions
  const handleShipmentTypeChange = (_, { key, value }, edit = false) => {
    if (!id) {
      form.setFieldValue("content", null);
    }
    const isDox = value?.toUpperCase() == "NON-DOX";
    setIsNonDox(isDox);

    if (isDox) {
      if (edit == false) {
        form.setFieldsValue(doxandNonDoxChange);
        setChildShipments([]);
      }
    } else {
      if (edit == false) {
        form.setFieldsValue({
          value: "0",
          weight: 50,
        });
      }
    }
    let output = [];

    contentDiscriptionData?.shipmentContent?.forEach((content) => {
      let filteredDescriptions =
        contentDiscriptionData?.shipmentDescription?.filter((description) => {
          return (
            description?.shipmentContentId === content?.shipmentContentId &&
            content?.shipmentTypeId === +key
          );
        });

      filteredDescriptions?.forEach((description) => {
        let combinedName = `${content?.shipmentContentName} - ${description?.shipmentDescriptionName}`;
        output.push({
          shipmentContentId: content?.shipmentContentId,
          shipmentContentName: combinedName?.toUpperCase(),
          shipmentTypeId: content?.shipmentTypeId,
        });
      });
    });
    setShipmentContentOptions(output);
  };

  const getDetails = async (id) => {
    setLoading(true);

    if (type === "API") {
      const inputDate = date;
      const [day, month, year] = inputDate.split("-");
      const formattedDate = `${year}-${month}-${day}`;
      const url = `${GET_UTM_API_BOOKING_DETAILS}`;
      let response = await API.Api(url).getwithParams({
        refDocumentNo: id,
        companyId: company?.key,
        startDate: formattedDate,
      });
      if (response?.status) {
        let extract = response?.response?.data?.data;
        setNewDataFormat(extract || {});
        let convert = convertCurrentToPrevBookingData({
          ...extract,
          documentNumber: "",
          childShipments: extract?.childShipments || [],
          eWayBills: extract?.eWayBills || [],
        });
        setEditShipmentDetails(convert);
      } else {
        setEditShipmentDetails(null);
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
      setLoading(false);
      return;
    }

    let url = `${GET_SINGEL_DOCUMENT_DETAILS_AWB_BE + +id}`;

    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let extract = response?.response?.data?.data?.items;
      setNewDataFormat(extract || {});
      let convert = convertCurrentToPrevBookingData(extract);
      setEditShipmentDetails(convert);
    } else {
      setLoading(false);
      setEditShipmentDetails(null);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  useEffect(() => {
    resetActiveState();
  }, [dropDownChanges]);

  useEffect(() => {
    const handleTabPress = (event) => {
      if (event.key === "Tab" || event.key === "Enter") {
        resetActiveState();
      }
    };

    document.addEventListener("keydown", handleTabPress);

    return () => {
      document.removeEventListener("keydown", handleTabPress);
    };
  }, [dropDownChanges]);

  // useEffect(() => {
  //   if (pinCodeServiceableStatus?.status == "success") {
  //     if (form.getFieldValue("documentNumber")?.length == 11) {
  //       form.setFieldValue("service", "FAST TRACK");
  //     } else {
  //       form.setFieldValue("service", "STANDARD");
  //     }
  //   }
  // }, [pinCodeServiceableStatus]);

  useEffect(() => {
    if (!id && !isClientAdmin) {
      getClients(company?.key);
    } else {
      if (id) {
        getDetails(id);
      }
      if (type === "API" || type === "OCR") {
        getClients(company?.key);
      }
    }
  }, [id]);

  useEffect(() => {
    if (id && editShipmentDetails) {
      setChildShipments(
        editShipmentDetails?.childShipmentDetails?.map((val) => {
          return {
            // ...val,
            childDocumentNumber: val?.childAwbNumber,
            weight: val?.weight || 0,
            width: val?.width || 0,
            length: val?.length || 0,
            height: val?.height || 0,
            editable: false,
            volumetricWeight:
              val?.volumetricWeight || val?.volumatricWeight || 0,
            value: val?.value || 0,
          };
        }) || []
      );
      // setSenderAddress(editShipmentDetails?.addressDetails);
      getDeliveryPincode(
        editShipmentDetails?.shipmentDetails?.destinationPincode,
        id,
        form.getFieldValue("service")
      );
      setFileList(
        editShipmentDetails?.files?.length
          ? [
              {
                name:
                  editShipmentDetails?.files &&
                  editShipmentDetails?.files[0]?.fileName?.split("/")?.pop(),
                url: editShipmentDetails?.files[0]?.fileName,
              },
            ]
          : null
      );

      setEditClientDepartment(editShipmentDetails?.shipmentDetails?.clientId);

      // setIsNonDox(
      //   editShipmentDetails?.shipmentDetails?.type?.toLowerCase() == "non-dox"
      // );
      setAllEwayBills(
        editShipmentDetails?.ewaybills.map((val) => {
          return { ...val, editable: false };
        }) || null
      );

      form.setFieldsValue({
        documentNumber: type == "API" ? "" : id,
        // documentNumber: value.documentNumber || null,
        // pickupPincode: value.pickupPincode || null,
        department: null,
        clientName: editShipmentDetails?.addressDetails?.senderName,
        deliveryPincode:
          editShipmentDetails?.shipmentDetails?.destinationPincode,
        areaId: editShipmentDetails?.addressDetails?.receiverAreaName,
        // // billRemark: value.billRemark,
        content: editShipmentDetails?.shipmentDetails?.content || null,
        // description: value?.billRemark || "",
        weight:
          editShipmentDetails?.shipmentDetails?.type?.toUpperCase() == "DOX"
            ? editShipmentDetails?.shipmentDetails?.weight * 1000 || 0
            : editShipmentDetails?.shipmentDetails?.weight || 0,
        length: editShipmentDetails?.shipmentDetails?.length || 0,
        width: editShipmentDetails?.shipmentDetails?.width || 0,
        height: editShipmentDetails?.shipmentDetails?.height || 0,
        volumetricWeight:
          editShipmentDetails?.shipmentDetails?.volumetricWeight || "0.00",
        value: editShipmentDetails?.shipmentDetails?.value || null,
        senderGstNumber: bookingDetails?.addressDetails?.senderGst || null,
        shipmentType:
          editShipmentDetails?.shipmentDetails?.type?.toUpperCase() || null,
        service:
          editShipmentDetails?.serviceDetails?.service?.toUpperCase() || null,
        travelBy:
          editShipmentDetails?.shipmentDetails?.travelBy?.toUpperCase() || null,

        receiverName: editShipmentDetails?.addressDetails?.receiverName || null,
        receiverAddress:
          editShipmentDetails?.addressDetails?.receiverAddressLine1 || null,

        mobileNumber:
          editShipmentDetails?.addressDetails?.receiverMobileNumber || "0",
        receiverEmail:
          editShipmentDetails?.addressDetails?.receiverEmail || null,
        billRemark: editShipmentDetails?.shipmentDetails?.description,
        insured: editShipmentDetails?.shipmentDetails?.insured ? "YES " : "NO",
        // clientCharges: clientEditChargeVal || 0,
      });
    }
  }, [editShipmentDetails, id]);

  useEffect(() => {
    if (id) {
      const fetchCharges = async () => {
        let getCharges = await getClientEditRates(id);
        setclientEditChargeVal(getCharges);
        form.setFieldsValue({
          clientCharges: getCharges || 0,
        });
      };
      fetchCharges();
    }
  }, [id]);

  useEffect(() => {
    form.setFieldsValue({
      shipmentType: "DOX",
      service: "STANDARD",
      travelBy: "SURFACE",
    });
    // handleShipmentTypeChange("_", { key: 1, value: "DOX" });
  }, []);

  useEffect(() => {
    if (id) {
      if (Object.entries(contentDiscriptionData)?.length !== 0) {
        handleShipmentTypeChange(
          "_",
          {
            key:
              editShipmentDetails?.shipmentDetails?.type?.toLowerCase() == "dox"
                ? 1
                : 2,
            value: editShipmentDetails?.shipmentDetails?.type,
          },
          true
        );
      }
    } else {
      if (Object.entries(contentDiscriptionData)?.length !== 0) {
        // form.setFieldsValue({
        //   shipmentType: "DOX",
        //   service: "STANDARD",
        //   travelBy: "SURFACE",
        // });
        handleShipmentTypeChange("_", { key: 1, value: "DOX" });
      }
    }
  }, [contentDiscriptionData, editShipmentDetails]);

  useEffect(() => {
    if (childShipments && !childDrawer) {
      if (form.getFieldValue("service")?.includes("vayuquick")) {
        getRateCard();
      }
    }
  }, [childShipments, childDrawer]);

  const onFormSubmit = (values) => {
    const now = Date.now();
    if (now - lastSubmitTime < THROTTLE_TIME) {
      return;
    }
    setLastSubmitTime(now);

    if (type === "OCR" || type === "API") {
      setRecentBookingsData(
        recentBookingsData?.filter(
          (item) => item?.awbNumber !== values?.documentNumber
        )
      );

      onSubmit(values);
      return;
    }
    if (id) {
      updateShipmentDetails(values);
    } else {
      onSubmit(values);
    }
  };

  const onSubmit = async (value) => {
    if (type !== "API" && type !== "OCR") {
      if (
        !bookingDetails?.addressDetails?.senderAddressLine1 ||
        !bookingDetails?.addressDetails?.senderPincode
      ) {
        message.error("Client details fetch error, please try again.");
        return;
      }
    }

    if (docValidate?.status == "error") {
      message.error(docValidate?.message);
      return;
    }

    if (pinCodeServiceableStatus?.status == "error") {
      message.error("Pincode is " + pinCodeServiceableStatus?.msg);
      return;
    }

    if (mainEwayValidationStatus?.status == "error") {
      message.error(mainEwayValidationStatus?.msg || "Invalid Eway");
      return;
    }

    if (value?.value > 50000 && allEwayBills?.length == 0) {
      message.error("Add E-way bill");
      return;
    }

    const obj = {
      mobileNumber: +value?.mobileNumber,
      emailAddress: value?.receiverEmail || null,
      address: value?.receiverAddress,
      name: value?.receiverName,
      bookingType: "Account",
    };

    const payload = {
      username: userInfo?.firstName + " " + userInfo?.lastName,
      documentNumber: value?.documentNumber || null,
      pickupPincode: bookingDetails?.addressDetails?.senderPincode || null,
      deliveryPincode:
        value?.deliveryPincode || pinCodeServiceableStatus?.pincode || null,
      areaId: null,
      shipmentType: value?.shipmentType || null,
      content: value?.content || null,
      description: value?.billRemark || "",
      weight: value?.weight || 0,
      length: value?.length || 0,
      width: value?.width || 0,
      height: value?.height || 0,
      volumatricWeight: value?.volumetricWeight || 0,
      value: value?.value || null,
      senderGstNumber: bookingDetails?.addressDetails?.senderGst || null,
      service:
        value?.service?.toUpperCase() === "VAYUQUICK"
          ? "vayuQuick"
          : value?.service?.toUpperCase() === "VAYUQUICK_PRO"
          ? "vayuQuick_pro"
          : currentEnv == "qa"
          ? firstLetterCapitaliseStr(value?.service)
          : value?.service,
      travelBy: value?.travelBy
        ? value?.travelBy?.charAt(0)?.toUpperCase() +
          value?.travelBy?.slice(1)?.toLowerCase()
        : null,
      destinationCpId: null,
      destinationHubId: value?.destinationHubId || null,
      insured: value?.insured?.toUpperCase() === "YES" ? true : false || false,
      clientId:
        currentEnv == "qa"
          ? clientDetails?.clientSevaId
          : clientDetails?.clientId,
      charges: null,
      clientPincode: bookingDetails?.addressDetails?.senderPincode,
      clientName: clientDetails?.clientName || null,
      childShipments:
        childShipments?.map((val) => {
          return { ...val, value: 0 };
        }) || [],
      ewayBills: allEwayBills?.length
        ? allEwayBills?.map(
            ({ id, error, errorMsg, editable, ...rest }) => rest
          )
        : null,
      addressDetails: {
        senderName: bookingDetails?.addressDetails?.senderName || null,
        senderCity: bookingDetails?.addressDetails?.senderCity || null,
        senderAddressLine1:
          bookingDetails?.addressDetails?.senderAddressLine1 || null,
        senderAddressLine2:
          bookingDetails?.addressDetails?.senderAddressLine2 || null,
        senderPincode: bookingDetails?.addressDetails?.senderPincode || null,
        senderState: bookingDetails?.addressDetails?.senderState || null,
        senderMobileNumber:
          bookingDetails?.addressDetails?.senderMobileNumber || null,
        senderEmail: bookingDetails?.addressDetails?.senderEmail || null,
        senderGst: bookingDetails?.addressDetails?.senderGst || null,
        areaName: bookingDetails?.addressDetails?.areaName || null,
        customerId: 0,
        receiverName: value?.receiverName || null,
        receiverAddressLine1: value?.receiverAddress || null,
        receiverAddressLine2: value?.addressLine2 || null,
        receiverCity:
          pinCodeServiceableStatus?.city || reviverStateCity?.city || null,
        receiverPincode: pinCodeServiceableStatus?.pincode || null,
        receiverState:
          pinCodeServiceableStatus?.state || reviverStateCity?.state || null,
        receiverAreaId: null,
        receiverAreaName: value?.areaId || null,
        receiverMobileNumber: +value?.mobileNumber || "0",
        receiverEmail: value?.receiverEmail || null,
        isGoogleAddress: useGoogleAddr,
      },
      returnAddressDetail:
        radioActive !== "default"
          ? savedReturnAddressList?.map((e, i) => ({
              ...e,
              isAddressEnabled: i === radioActive,
            }))
          : savedReturnAddressList?.map((e) => ({
              ...e,
              isAddressEnabled: false,
            })),
      files: fileList?.length
        ? fileList?.map((val) => ({
            fileName: val?.response?.data?.filePath,
            fileId: val?.documentType,
          }))
        : [],
      userDetailsDto: containsAllPairs(
        obj,
        reviverNameAndAddress?.receiverDetails || []
      ),
    };

    if (type === "OCR" || type === "API" || currentEnv === "qa") {
      const newPayload = transformToNewFormat(payload, newDataFormat, type);

      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userinfo"));

        let url = CONFIRM_BOOKING_UTM;

        if (type == "CREDIT") {
          delete newPayload?.metadata?.utm;
        }

        const response = await API.Api(url).postCustomHeader(newPayload, {
          user_id: userInfo?.sevasetuUserId,
          cpid: userInfo?.cpId,
        });
        if (response?.status) {
          openNotificationWithIcon("success", payload?.documentNumber);
          if (type == "CREDIT") {
            resetCallBack(
              payload?.userDetailsDto?.receiverDetails[0]?.userId == null
            );
          }
        } else {
          setLoading(false);
          message.error(
            response?.response?.data?.message ||
              response?.data?.message ||
              response?.response?.data ||
              "Network error"
          );
        }
      } catch (error) {
        console.log("error OCR: ", error);
      }
    } else {
      const response = await submitWithPostDetails(payload, company?.key);

      if (response?.status) {
        setLoading(false);
        openNotificationWithIcon("success", payload?.documentNumber);
        resetCallBack(
          payload?.userDetailsDto?.receiverDetails[0]?.userId == null
        );
        if (printer) {
          await handlePrinting(payload);
        }
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message ||
            response?.data?.message ||
            response?.response?.data ||
            "Network error"
        );
      }
    }
  };

  const updateShipmentDetails = async (value) => {
    if (value?.value > 50000 && allEwayBills?.length == 0) {
      message.error("Add E-way bill");
      return;
    }

    let payload = {
      charges: value?.clientCharges,
      content: value?.content || null,
      description: value?.billRemark || "",
      value: value?.value || null,
      weight: value?.weight || 0,
      length: value?.length || 0,
      width: value?.width || 0,
      height: value?.height || 0,
      volWeight: value?.volumetricWeight || "0.00",
      insured: value?.insured === "yes" ? true : false || false,
      file: [],
      receiverAddress: {
        addressType: "string",
        receiverName: value?.receiverName || null,
        receiverAddressLine1: value?.receiverAddress || null,
        receiverAddressLine2: value?.addressLine2 || null,
        receiverCity: editShipmentDetails?.addressDetails?.receiverCity || null,
        receiverState:
          editShipmentDetails?.addressDetails?.receiverState || null,
        receiverPincode:
          editShipmentDetails?.addressDetails?.receiverPincode || null,
        receiverMobileNumber: +value?.mobileNumber || "0",
        receiverEmail: value?.receiverEmail || null,
      },
      childShipments:
        childShipments?.map(({ volumetricWeight, editable, ...rest }) => ({
          ...rest,
          value: 0,
          volumatricWeight: volumetricWeight,
        })) || [],
      ewayBills: allEwayBills?.length
        ? allEwayBills.map(({ id, error, editable, errorMsg, ...rest }) => rest)
        : [],
    };

    setLoading(true);

    let res = await API.Api(UPDATE_SINGLE_BOOKING + id).patchIdHeader(payload);

    if (res?.status) {
      setLoading(false);
      message.success("Booking updated successfully");

      let tempIndex = recentBookingsData?.findIndex(
        (item) => item?.awbNumber == id
      );

      if (!recentBookingsData[tempIndex]) {
        recentBookingsData[tempIndex] = {};
      }

      recentBookingsData[tempIndex].weight = value?.weight;
      recentBookingsData[tempIndex].receiverName = value?.receiverName;

      localStorage.setItem(
        "recentBookings",
        JSON.stringify(recentBookingsData)
      );

      navigate("/viewBooking", { state: history?.state });
      if (printer) {
        await handlePrinting(payload);
      }
    } else {
      setLoading(false);
      message.error(res?.response?.data?.message || "Network error");
    }
  };

  const resetCallBack = (oldRevcUser) => {
    returnAddressform.resetFields();
    setAllEwayBills([]);
    setFileList([]);
    setChildShipments([]);
    setEwayBillCheck(false);
    setPinCodeServiceableStatus({});
    setUseGoogleAddr(false);
    setNonDoxValueReq(true);
    ewayForm.resetFields();
    childDrawerform.resetFields();

    const keysToInclude = [
      "clientName",
      "shipmentType",
      "travelBy",
      "service",
      "documentNumber",
      "department",
    ];
    const values = form.getFieldValue();
    const currentDateTime = moment()?.format("YYYY-MM-DD HH:mm:ss");

    let temp = [...recentBookingsData];
    if (type !== "OCR") {
      temp.unshift({
        awbNumber: +values?.documentNumber,
        bookingTime: currentDateTime || "NA",
        bookingType: "Account",
        serviceType: normalizeService(values?.service) || "NA",
        travelBy: values?.travelBy || "NA",
        type: values?.shipmentType || "Na",
        senderName: values?.clientName || "NA",
        weight:
          +values?.weight +
            +childShipments?.reduce((acc, curr) => acc + +curr?.weight, 0) +
            (values?.shipmentType?.toUpperCase() == "NON-DOX"
              ? " KG"
              : " GMS") || "NA",
        toCenter: reviverStateCity?.city || "NA",
        receiverName: values?.receiverName || "NA",
      });
      temp = temp?.slice(0, 5);

      setRecentBookingsData(temp);
      localStorage.setItem("creditRecentBookings", JSON.stringify(temp || []));
      setReviverStateCity({});
    }
    form.resetFields(
      Object.keys(values)?.filter((key) => !keysToInclude?.includes(key))
    );
    let documentNumber = +values?.documentNumber;

    form.setFieldsValue({
      documentNumber: ++documentNumber,
      value: "0",
      travelBy: "SURFACE",
    });

    if (values?.shipmentType?.toUpperCase() == "NON-DOX") {
      form.setFieldsValue({
        weight: 1,
        length: 0,
        width: 0,
        height: 0,
        volumetricWeight: "0.00",
      });
    } else {
      form.setFieldsValue({
        weight: 50,
      });
    }

    getFocusFirstInput("documentNumber");
    window.scrollTo(0, 0);
  };

  const handleFilter = (inputValue) => {
    const filtered = clientList?.filter((option) =>
      option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
    );
    setFilteredOptions(filtered);
  };

  const filterOptionforService = (input, option) =>
    (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase());

  const [printDoc, setPrintDoc] = useState(null);
  const componentRef = useRef();

  const printHandle = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => {
      setLoading(false);
    },
    onAfterPrint: () => {
      setLoading(false);
      setPrintDoc(null);
    },
    onPrintError: () => {
      setLoading(false);
      console.error("An error occurred while printing.");
    },
  });

  const creditPrint = (id) => {
    setLoading(true);
    setPrintDoc(id);
  };

  const viewBookingSummaryResponse = useSelector(
    (state) => state.appReducer.getSingleBookingReducer,
    shallowEqual
  );

  const {
    result: singleResult,
    error,
    fetching: loading2,
  } = viewBookingSummaryResponse;

  useEffect(() => {
    if (error !== null) {
      setLoading(false);
      message.error(error || "Internal server error");
      return;
    }
    if (singleResult && printDoc) {
      setTimeout(() => {
        setLoading(false);
        printHandle();
      }, 100);
    }
  }, [singleResult, error, printDoc]);

  const openNotificationWithIcon = (type, awb) => {
    notification[type]({
      message: <h3 className="alert-">Booking successfully completed</h3>,
      duration: 5,
      className: "book-success-alert",
      description: (
        <>
          <h5 className="order-id">
            Document no.&nbsp; <b>{form.getFieldValue("documentNumber")}</b>
          </h5>

          {childShipments?.length > 0 ? (
            <h5>
              Child document no.&nbsp;{" "}
              <b>
                {childShipments
                  ?.map((e, i) => e?.childDocumentNumber)
                  ?.join(", ")}
              </b>
            </h5>
          ) : (
            ""
          )}

          <a onClick={() => creditPrint(awb)}>Click here to print receipt</a>
        </>
      ),
    });
  };

  const resetActiveState = () => {
    document.querySelectorAll(".ant-select-item-option")?.forEach((option) => {
      option.classList.remove("ant-select-item-option-active");
    });
  };

  let contentDiscriptionOptions = contentDiscriptionData?.shipmentType?.map(
    (type) => ({
      value: type?.shipmentTypeName?.toUpperCase(),
      label: type?.shipmentTypeName?.toUpperCase(),
      key: type?.shipmentTypeId,
      id: type?.shipmentTypeId,
    })
  );

  const settingDocFeild = (name, message) => {
    setDocValidate({ status: message ? "error" : null, message: message });
  };

  let tempOptions = [
    {
      value: "STANDARD",
      label: "STANDARD",
    },
    {
      value: "FAST TRACK",
      label: "FAST TRACK",
    },
    { value: "VALUE PLUS", label: "VALUE PLUS" },
  ];

  const handleValidationError = (message) => {
    setdocLoading(false);
    setServiceOptions(tempOptions);
    settingDocFeild("documentNumber", message);
  };

  const handleServiceOptions = (serviceValue) => {
    const docTypeMapping = {
      FastTrack: "FAST TRACK",
      Standard: "STANDARD",
      ValuePlus: "VALUE PLUS",
    };

    const mappedServiceValue = serviceValue?.map((val) => docTypeMapping[val]);

    const userInfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
    let availableOptions = [...tempOptions];

    if (userInfo?.state?.toUpperCase()?.trim() !== "GUJARAT") {
      availableOptions = availableOptions?.filter(
        (option) => option?.value !== "VALUE PLUS"
      );
    }

    return availableOptions?.filter((item) =>
      mappedServiceValue?.includes(item?.value)
    );
  };

  const handleDocumentInputChange = async (e) => {
    let formDoc = form.getFieldValue("documentNumber")?.toString()?.trim();

    if (!formDoc) {
      message.error("Enter document number!");
      return;
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (!clientDetails) {
      message.error("Select client");
      return;
    }
    setServiceOptions([]);

    debounceTimeout.current = setTimeout(async () => {
      if (formDoc?.length == 11 || formDoc?.length == 14) {
        try {
          setdocLoading(true);

          const response = await documentValidate(formDoc, "Account");

          if (response?.response?.data?.data) {
            setdocLoading(false);
            settingDocFeild("documentNumber", null);

            const serviceValue = response?.response?.data?.data?.data || [];
            const nextInput = document.getElementById("deliveryPincode");
            if (nextInput) {
              nextInput.focus();
            }

            if (serviceValue && serviceValue[0] === "ChildBadgeCourier") {
              setServiceOptions([]);
              form.setFieldValue("service", null);
              settingDocFeild("documentNumber", "Child doc is not allowed");
              return;
            }

            const availableServices = handleServiceOptions(serviceValue);

            console.log(availableServices, "availableServices");
            console.log(formDoc, "formDoc");
            console.log(formDoc?.length, "formDoc length");
            console.log(serviceValue, "serviceValue");

            if (formDoc?.length === 14) {
              form.setFieldValue("service", "STANDARD");
              setServiceOptions(availableServices);
            } else {
              form.setFieldValue("service", "FAST TRACK");
              setServiceOptions(availableServices);
              const deliveryPincode = form.getFieldValue("deliveryPincode");
              if (deliveryPincode) {
                getDeliveryPincode(deliveryPincode, id, "FAST TRACK", true);
              }
            }
          } else {
            handleValidationError(
              response?.response?.data?.message || "Network error!"
            );
          }
        } catch (error) {
          handleValidationError("Internal server error");
        }
      } else {
        handleValidationError("Document number must be 11 or 14 digits!");
      }
    }, 600);
  };

  const handlePincodeSearch = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      if (value?.length > 0) {
        const filtered = allPincodes
          ?.filter((item) => {
            const pincode = String(item?.Pincode);
            const searchValue = String(value);

            if (searchValue?.length === 6) {
              return pincode === searchValue;
            }

            return pincode?.startsWith(searchValue);
          })
          .map((item) => ({
            value: item?.Pincode,
            label: `${item?.Pincode}`,
          }));

        if (filtered?.length > 0) {
          setActivePinOption(filtered[0]?.value);
          setAllPinOptions(filtered);
        } else {
          setActivePinOption(null);
          setAllPinOptions([]);
        }
      } else {
        setActivePinOption(null);
        setAllPinOptions([]);
      }
    }, 100);
  };

  const handleSetChildDrawer = React.useCallback(
    (e) => {
      const inputFieldId = "billRemark";
      const targetElement = document.getElementById(inputFieldId);
      if (targetElement) {
        targetElement?.focus();
      }
      setChildDrawer(e);
    },
    [setChildDrawer]
  );

  const handleSetEwayDrawer = React.useCallback(
    (e) => {
      const targetElement = document.getElementById(
        isNonDox == true ? "childBtn" : "billRemark"
      );

      if (targetElement) {
        targetElement?.focus();
      }
      setEwayDrawer(e);
    },
    [setEwayDrawer, isNonDox]
  );

  const handleRecentBookingsData = (data) => {
    setRecentBookingsData(data);
  };

  const handleChargableWeight = () => {
    let values = form.getFieldsValue();

    let totalChargeableWeight = 0;

    if (childShipments?.length) {
      totalChargeableWeight = childShipments?.reduce((sum, item) => {
        const maxWeight = Math.max(
          parseFloat(item.weight),
          parseFloat(item.volumetricWeight)
        );
        return sum + maxWeight;
      }, 0);
    }

    const parentMaxWgt = Math.max(
      parseFloat(values?.weight),
      parseFloat(values?.volumetricWeight)
    );

    const formattedWeight = childShipments?.length
      ? +totalChargeableWeight.toFixed(2) + +parentMaxWgt.toFixed(2)
      : +parentMaxWgt.toFixed(2);

    return formattedWeight || 0;
  };

  const getRateCard = async () => {
    const token = getToken();

    let values = form.getFieldsValue();

    if (pinCodeServiceableStatus?.status !== "success") {
      return;
    }

    let isNonDox = form.getFieldValue("shipmentType")?.toUpperCase() !== "DOX";

    const serviceMap = {
      vayuquick: "vayuQuick",
      vayuquick_pro: "vayuQuickPro",
    };

    const serviceInput = values?.service?.trim()?.toLowerCase();

    const matchedKey = Object.keys(serviceMap).find(
      (key) => key?.toLowerCase() === serviceInput
    );

    const rateCategory = matchedKey ? serviceMap[matchedKey] : "";

    const payload = {
      type: "ACCOUNT",
      userId: clientDetails?.clientId?.toString(),
      amount: +values?.value || 0,
      noOfShipments: 1,
      isGstApplicable: false,
      fromPincode: user_premiseId?.premises?.pincode,
      calculateGst: company?.isRegularNGST,
      toPincode: +values?.deliveryPincode,
      isInsured: values?.insured?.toUpperCase() == "YES" ? true : false,
      isCod: false,
      isPod: false,
      isOda1: false,
      isOda2: false,
      senderGst: values?.senderGST || null,
      rateCategory: rateCategory,
      travelMode:
        form.getFieldValue("travelBy")?.toUpperCase() === "SURFACE"
          ? "surface"
          : "air",
      weight: isNonDox ? +values?.weight * 1000 : +values?.weight,
      productType:
        form.getFieldValue("shipmentType")?.toUpperCase() === "DOX"
          ? "dox"
          : "nonDox",
    };
    let getChargealeWgt = 0;

    if (isNonDox) {
      getChargealeWgt = handleChargableWeight();
      Object.assign(payload, {
        length: +form.getFieldValue("length"),
        height: +form.getFieldValue("height"),
        width: +form.getFieldValue("width"),
        volumetricWeight: +getChargealeWgt,
      });
    }

    setLoading(true);

    let url;
    if (currentEnv == "qa") {
      url =
        "https://sandbox.bookingapis.innofulfill.com/ratecard/rate-calculation/shipment";
    } else {
      url =
        "https://bookingapis.innofulfill.com/ratecard/rate-calculation/shipment";
    }

    try {
      const response = await axios.post(url, payload, {
        headers: { Authorization: token },
      });

      const rateValue =
        response?.data?.rate?.[payload?.productType]?.[payload?.travelMode]?.[
          payload?.rateCategory
        ];

      if (rateValue) {
        setVayuCharges({
          ...rateValue,
          weight:
            +getChargealeWgt === 0
              ? +form.getFieldValue("weight")
              : getChargealeWgt,
          type:
            form.getFieldValue("service") == "vayuquick"
              ? "Vayu Quick"
              : "Vayu Quick Pro",
        });
        setLoading(false);
      } else {
        setLoading(false);
        message.error("Rate value not found");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || "Rate value not found");
      setLoading(false);
    }
  };

  function handleFormValueChange(temp) {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const keywordsNull = ["documentNumber", "deliveryPincode"];

    function checkForKeyNull(temp, keywords) {
      const tempKeys = Object?.keys(temp);
      return keywordsNull?.some((keyword) => tempKeys?.includes(keyword));
    }

    if (checkForKeyNull(temp, keywordsNull)) {
      setVayuCharges(null);
      return;
    }

    const keywords = [
      "weight",
      "service",
      "shipmentType",
      "value",
      "width",
      "length",
      "height",
    ];

    function checkForKey(temp, keywords) {
      const tempKeys = Object?.keys(temp);
      return keywords.some((keyword) => tempKeys?.includes(keyword));
    }

    if (checkForKey(temp, keywords)) {
      debounceTimeout.current = setTimeout(async () => {
        if (form.getFieldValue("service")?.includes("vayuquick")) {
          getRateCard();
        } else {
          setVayuCharges(null);
        }
      }, 300);
    }
  }

  const handleKeyDown = (event, dataOptions, formItemName, value = "value") => {
    // eslint-disable-next-line no-case-declarations
    let activeOption = document.querySelector(".ant-select-item-option-active");

    switch (event.key) {
      case "Enter":
        setdropDownChanges(!dropDownChanges);
        event?.preventDefault();

        if (formItemName == "insured") {
          const inputFieldId = "billRemark";
          const targetElement = document.getElementById(inputFieldId);
          if (targetElement) {
            targetElement?.focus();
            targetElement?.select();
          }
          return;
        }

        handleOnEnter(event);

        break;

      case "Tab":
        // handleOnEnter(event);

        setdropDownChanges(!dropDownChanges);

        if (activeOption) {
          const value = activeOption.getAttribute("title");

          if (formItemName == "deliveryPincode") {
            const optionExists = dataOptions?.some(
              (option) => option?.value == +value?.slice(0, 6)
            );
            if (optionExists) {
              form.setFieldsValue({
                [formItemName]: value?.slice(0, 6) || activePinOption,
              });

              if (+pinCodeServiceableStatus?.pincode !== +value?.slice(0, 6)) {
                getDeliveryPincode(
                  value?.slice(0, 6) || activePinOption,
                  id,
                  form.getFieldValue("service")
                );
              }
            }
            return;
          }

          const optionExists = dataOptions?.some(
            (option) =>
              String(option?.value || "")?.toLowerCase() ===
              String(value || "")?.toLowerCase()
          );

          if (optionExists) {
            form.setFieldsValue({ [formItemName]: value });
            if (formItemName === "shipmentType") {
              form.setFieldValue("content", null);
              const fil = contentDiscriptionData?.shipmentType?.find(
                (option) =>
                  option?.shipmentTypeName?.toUpperCase() ===
                  value?.toUpperCase()
              );
              const newVal = {
                key: fil?.shipmentTypeId,
                value: fil?.shipmentTypeName?.toUpperCase(),
              };

              handleShipmentTypeChange("_", newVal);
            }
          }
        }

        break;

      default:
        break;
    }
  };

  const handleAPIKeyDown = (
    event,
    dataOptions,
    formItemName,
    formKeyName = "value",
    dropDownName
  ) => {
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        setdropDownChanges(!dropDownChanges);
        handleOnEnter(event);

        break;

      case "Tab":
        handleOnEnter(event);
        setdropDownChanges(!dropDownChanges);
        // Get the active option
        // eslint-disable-next-line no-case-declarations
        let activeOption = document.querySelector(
          ".ant-select-item-option-active"
        );

        if (activeOption) {
          const value = activeOption.getAttribute("title");

          const optionExists = dataOptions?.find(
            (option) =>
              option[formKeyName]?.toLowerCase() === value?.toLowerCase()
          );

          if (optionExists) {
            if (dropDownName === "clients") {
              form.setFieldsValue({ [formItemName]: value });
              // console.log(optionExists, "optionExists");
              setRadioActive("default");
              //setClientDepartment(optionExists);
              if (currentEnv == "qa") {
                getDepartMentQA(optionExists);
              } else {
                setClientDepartment(optionExists);
              }
            }

            return;
          }
        }
        break;
      default:
        break;
    }
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="credit-container">
        {ewayDrawer && (
          <EwayBillDrawer
            allEwayBills={allEwayBills}
            setOpen={handleSetEwayDrawer}
            open={ewayDrawer}
            setAllEwayBills={setAllEwayBills}
            ewayForm={ewayForm}
          />
        )}

        {childDrawer && (
          <ChildDrawer
            childDrawerform={childDrawerform}
            childShipments={childShipments || []}
            setChildShipments={setChildShipments}
            editChildDetails={editShipmentDetails?.childShipmentDetails || []}
            setOpen={handleSetChildDrawer}
            open={childDrawer}
          />
        )}

        <div style={{ background: "#F5F8FD", padding: "0.4rem" }}>
          <div className="d-flex" style={{ alignItems: "center" }}>
            <Heading
              title={
                type === "OCR" || type === "API"
                  ? `${type} Booking`
                  : "Credit Booking"
              }
              custom={true}
              navigateTo={"/viewBooking"}
            />

            <div style={{ marginLeft: "3rem", marginBottom: "4px" }}>
              Company Name: <b> {company?.label}</b>
            </div>
            <div style={{ marginLeft: "3rem", marginBottom: "4px" }}>
              CP Pincode: <b> {user_premiseId?.premises?.pincode}</b>
            </div>
          </div>
          <Row
            style={{ background: "#FFFFFF" }}
            className={"account-tab-container"}
          >
            <div style={{ width: "78%", padding: "10px 22px 0 22px" }}>
              <CreditFormItems
                handleTabEnter={handleTabEnter}
                pincodeLoading={pincodeLoading}
                eWayBillHandle={eWayBillHandle}
                onFormSubmit={onFormSubmit}
                handleFormValueChange={handleFormValueChange}
                handleFilter={handleFilter}
                form={form}
                docValidate={docValidate}
                setMainEwayValidationStatus={setMainEwayValidationStatus}
                mainEwayValidationStatus={mainEwayValidationStatus}
                insuredOptions={insuredOptions}
                travelByOptions={travelByOptions}
                servicesOptions={servicesOptions}
                pinCodeServiceableStatus={pinCodeServiceableStatus}
                allEwayBills={allEwayBills}
                childShipments={childShipments}
                reviverNameAndAddress={reviverNameAndAddress}
                setPinCodeServiceableStatus={setPinCodeServiceableStatus}
                getDeliveryPincode={getDeliveryPincode}
                handleOnEnter={handleOnEnter}
                isNonDox={isNonDox}
                filteredOptions={filteredOptions}
                handleAPIKeyDown={handleAPIKeyDown}
                handleKeyDown={handleKeyDown}
                getRateCard={getRateCard}
                handleDocumentInputChange={handleDocumentInputChange}
                handleValidationError={handleValidationError}
                handlePincodeSearch={handlePincodeSearch}
                allPinOptions={allPinOptions}
                activePinOption={activePinOption}
                setActivePinOption={setActivePinOption}
                getDepartMentQA={getDepartMentQA}
                setClientDepartment={setClientDepartment}
                department={department}
                dropDownChanges={dropDownChanges}
                setdropDownChanges={setdropDownChanges}
                handleShipmentTypeChange={handleShipmentTypeChange}
                contentDiscriptionOptions={contentDiscriptionOptions}
                filterOptionforService={filterOptionforService}
                resetForm={resetForm}
                setUseGoogleAddr={setUseGoogleAddr}
                nonDoxValueReq={nonDoxValueReq}
                setNonDoxValueReq={setNonDoxValueReq}
                setEwayBillCheck={setEwayBillCheck}
                setAllEwayBills={setAllEwayBills}
                shipmentContentOptions={shipmentContentOptions}
                setEwayDrawer={setEwayDrawer}
                ewayBillCheck={ewayBillCheck}
                setChildDrawer={setChildDrawer}
                setRadioActive={setRadioActive}
                disableEdit={
                  type === "OCR" || type === "API" ? false : id ? true : false
                }
                setFileList={setFileList}
                fileList={fileList}
                editShipmentDetails={editShipmentDetails}
                docLoading={docLoading}
                clientEditChargeVal={clientEditChargeVal}
                id={id}
                isClientAdmin={isClientAdmin}
                {...customProps}
              />
              <Row style={{ paddingBottom: "12px" }}>
                <Col lg={24} sm={24} md={24}>
                  <div>
                    {type === "OCR" || type === "API" ? (
                      <NewRecentBookingTable
                        bookingType={type}
                        recentBookingsData={recentBookingsData}
                        handleRecentBookingsData={handleRecentBookingsData}
                      />
                    ) : (
                      <RecentBooking
                        bookingType="Account"
                        recentBookingsData={recentBookingsData}
                        handleRecentBookingsData={handleRecentBookingsData}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            <div style={{ width: "22%" }} className="pt-1 card-container">
              {type === "OCR" ? (
                <ImageViewer fileList={fileList} />
              ) : senderAddress?.senderName &&
                radioActive === "default" &&
                clientDetails?.clientId ? (
                <AddressCard
                  setReturnAddressDrawer={setReturnAddressDrawer}
                  capitalize={capitalize}
                  senderAddress={senderAddress}
                />
              ) : radioActive !== "default" && clientDetails?.clientId ? (
                <AddressCard
                  setReturnAddressDrawer={setReturnAddressDrawer}
                  capitalize={capitalize}
                  senderAddress={savedReturnAddressList[radioActive]}
                />
              ) : (
                <Card
                  size="small"
                  title="Sender Address"
                  className="cardDesing"
                >
                  <Empty description={false} />
                </Card>
              )}

              {vayuCharges && (
                <div>
                  <Card
                    size="small"
                    title="Charges summary"
                    className="cardDesing"
                  >
                    <div style={{ paddingLeft: "10px" }}>
                      <p>
                        Service Type: <b>{vayuCharges?.type}</b>
                      </p>
                      <p>
                        Weight: <b>{vayuCharges?.weight || 0}</b>
                      </p>
                      <p>
                        Rate: <b>{vayuCharges?.total}</b>
                      </p>
                    </div>
                  </Card>
                </div>
              )}
            </div>
          </Row>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <PrintBooking
          currentDateRange={null}
          ref={componentRef}
          id={printDoc}
          idList={null}
          loading={loading}
          setLoading={setLoading}
          callPrint={() => printHandle()}
        />
      </div>
    </Spin>
  );
};

export default memo(BaseCreditBooking);
